export default "__VITE_ASSET__$TBC$xgq__"